// @flow

import type { IncomingPayment } from '@tectonics/prs/incoming-payment';

export function getThreeDSecureRedirectUrl(incomingPayment: IncomingPayment): ?string {
  if (incomingPayment.threedsecure) {
    return incomingPayment.threedsecure.threeds_redirect_url;
  }
  return undefined;
}

export function getSafeThreeDSecureRedirectUrl(incomingPayment: IncomingPayment): string {
  const redirectUrl = getThreeDSecureRedirectUrl(incomingPayment);

  if (!redirectUrl)
    throw new Error('getSafeThreeDSecureRedirectUrl - there is no threedsecure redirect url in incoming payment');

  return redirectUrl;
}
